export default __webpack_public_path__ + "static/media/SndLowerXSlideDown2.119d74fc.mp3";